import { HStack, Image, Stack, Text } from "@chakra-ui/react";
import Colors from "../../assets/colors/Colors";
import payError from "../../assets/images/payError.svg";
import paySuccess from "../../assets/images/typcn_tick.svg";
const GrubErrorMessage = (props) => {
    return (
        <HStack
            // minH="3.13rem"
            w={props.width}
            // bg="#FFECE2"
            // pt="1rem"
            // pb="0.5rem"
            justifyContent="center"
            alignItems="center"
            alignSelf="center"
            // borderRadius="0.44rem"
            mt="1rem"
        >
            <Stack
                gap="0.5rem"
                alignItems="center"
                justifyContent="center"
                alignSelf="center"
            >
                <Image
                    src={
                        undefined == props.isError || props.isError == true
                            ? payError
                            : paySuccess
                    }
                    alt="warning"
                    boxSize="1.5rem"
                />
            </Stack>
            <Stack w={"90%"} pl="0">
                <Text
                    color={
                        undefined == props.isError || props.isError == true
                            ? Colors.posCancleButtonMuiRed
                            : "#09B825"
                    }
                    fontSize={"0.94rem"}
                    lineHeight={"1.41rem"}
                    fontWeight={300}
                >
                    {props.errorMessage}
                </Text>
            </Stack>
        </HStack>
    );
};

export default GrubErrorMessage;
